import { z } from 'zod'
import { EndDate, Id, IsActive, StartDate, UpdateDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace AddressObjectType {
  export interface Data {
    /** @description Unique identifier of the record */
    readonly id: number

    /** @description Address object level */
    readonly level: number

    /** @description Short name of the address object type */
    readonly shortName: string

    /** @description Full name of the address object type */
    readonly name: string

    /** @description Description */
    readonly description?: string

    /** @description Date of entry or update of the record */
    readonly updatedDate: Date

    /** @description Start of record validity */
    readonly startDate: Date

    /** @description End of record validity */
    readonly endDate: Date

    /** @description Activity status */
    readonly isActive: boolean
  }
}

/** @description Information about the address object type */
export class AddressObjectType extends GarItem<
  'AddressObjectType',
  AddressObjectType.Data
> {
  static readonly SCHEMA: GarItem.Schema<AddressObjectType.Data> = z
    .strictObject({
      ID: Id,

      LEVEL: z.coerce.number<string>().int().describe('Address object level'),

      SHORTNAME: z.string().describe('Short name of the address object type'),

      NAME: z.string().describe('Full name of the address object type'),

      DESC: z.string().describe('Description').optional(),

      UPDATEDATE: UpdateDate,

      STARTDATE: StartDate,

      ENDDATE: EndDate,

      ISACTIVE: IsActive,
    })
    .transform<AddressObjectType.Data>(attributes => ({
      id: attributes.ID,
      level: attributes.LEVEL,
      shortName: attributes.SHORTNAME,
      name: attributes.NAME,
      description: attributes.DESC,
      updatedDate: attributes.UPDATEDATE,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
      isActive: attributes.ISACTIVE,
    }))

  readonly type = 'AddressObjectType'

  protected get schema() {
    return AddressObjectType.SCHEMA
  }
}
